export default "__VITE_ASSET__Bfsb5MPB__"